class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelector("#CartDrawer-Overlay").addEventListener(
      "click",
      this.close.bind(this)
    );
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#cart-icon-bubble");
    if (!cartLink) return;

    cartLink.setAttribute("role", "button");
    cartLink.setAttribute("aria-haspopup", "dialog");
    cartLink.addEventListener("click", (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener("keydown", (event) => {
      if (event.code.toUpperCase() === "SPACE") {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute("role"))
      this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add("animate", "active");
    });

    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = this.classList.contains("is-empty")
          ? this.querySelector(".drawer__inner-empty")
          : document.getElementById("CartDrawer");

        // Fallback: if empty state element doesn't exist, use the main drawer inner
        const finalContainer =
          containerToTrapFocusOn ||
          this.querySelector(".drawer__inner") ||
          this;
        const focusElement =
          this.querySelector(".drawer__inner") ||
          this.querySelector(".drawer__close");

        trapFocus(finalContainer, focusElement);
      },
      { once: true }
    );

    document.body.classList.add("overflow-hidden");
  }

  close() {
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden");
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    cartDrawerNote.setAttribute("aria-expanded", "false");

    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute(
        "aria-controls",
        cartDrawerNote.nextElementSibling.id
      );
    }

    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open")
      );
    });

    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector(".drawer__inner").classList.contains("is-empty") &&
      this.querySelector(".drawer__inner").classList.remove("is-empty");
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    setTimeout(() => {
      this.querySelector("#CartDrawer-Overlay").addEventListener(
        "click",
        this.close.bind(this)
      );
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    const parsed = new DOMParser().parseFromString(html, "text/html");
    const element = parsed.querySelector(selector);
    return element ? element.innerHTML : "";
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        selector: "#CartDrawer",
      },
      {
        id: "cart-icon-bubble",
      },
    ];
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".drawer__inner",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
    ];
  }
}

customElements.define("cart-drawer-items", CartDrawerItems);

// Cart Drawer Enhanced Functionality
document.addEventListener("DOMContentLoaded", function () {
  // ============================================
  // Auto-add companion product to cart
  // ============================================
  // Nếu trong giỏ hàng có ít nhất 1 sản phẩm, thì luôn đảm bảo sản phẩm companion cũng nằm trong đó
  const COMPANION_PRODUCT_HANDLE = "special-free-jewelry-box"; // Gift 1
  let companionVariantId = null;
  let companionProductId = null;

  const COMPANION_PRODUCT_HANDLE_2 = "earring"; // Gift 2
  let companionVariantId2 = null;
  let companionProductId2 = null;

  let isCheckingCompanion = false;

  // ======= Fetch variant ID gift 1 =======
  async function fetchCompanionVariantId() {
    if (companionVariantId) return companionVariantId;

    try {
      const res = await fetch(`/products/${COMPANION_PRODUCT_HANDLE}.js`);
      if (res.ok) {
        const product = await res.json();
        companionProductId = product.id;
        const variant =
          product.variants.find((v) => v.available) || product.variants[0];
        if (variant) {
          companionVariantId = variant.id;
          return companionVariantId;
        }
      }
    } catch (e) {
      console.error("Error fetching gift 1:", e);
    }
    return null;
  }

  // ======= Fetch variant ID gift 2 =======
  async function fetchCompanionVariantId2() {
    if (companionVariantId2) return companionVariantId2;

    try {
      const res = await fetch(`/products/${COMPANION_PRODUCT_HANDLE_2}.js`);
      if (res.ok) {
        const product = await res.json();
        companionProductId2 = product.id;
        const variant =
          product.variants.find((v) => v.available) || product.variants[0];
        if (variant) {
          companionVariantId2 = variant.id;
          return companionVariantId2;
        }
      }
    } catch (e) {
      console.error("Error fetching gift 2:", e);
    }
    return null;
  }

  // ======= Kiểm tra tổng giá đơn hàng >= 3000 =======
  function isCartEligibleForSecondGift(cart) {
    const totalAfterDiscount = cart.total_price / 100; // cents -> tiền thật
    return totalAfterDiscount >= 3000;
  }

  // ======= Hàm xóa sản phẩm trong cart =======
  async function removeCartItem(itemKey) {
    try {
      const res = await fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          updates: { [itemKey]: 0 },
          sections: ["cart-drawer", "cart-icon-bubble"],
          sections_url: window.location.pathname,
        }),
      });
      if (res.ok) {
        const result = await res.json();
        if (result.sections) updateCartUI(result.sections);
      }
    } catch (e) {
      console.error("Error removing cart item:", e);
    }
  }

  // ======= Hàm chính =======
  // Kiểm tra giỏ hàng và tự động thêm/xóa quà tặng (gift 1 & gift 2)
  async function checkAndAddCompanionProduct() {
    if (isCheckingCompanion) return;
    isCheckingCompanion = true;

    try {
      let cartRes = await fetch("/cart.js");
      if (!cartRes.ok) return;
      let cart = await cartRes.json();

      if (!cart.items || cart.items.length === 0) return;

      const variantId1 = await fetchCompanionVariantId();
      const variantId2 = await fetchCompanionVariantId2();
      if (!variantId1 || !variantId2) return;

      // Xác định xem hiện tại có sản phẩm không phải quà tặng hay không
      const hasNonGiftItems = cart.items.some(
        (i) =>
          !(
            i.variant_id === variantId1 ||
            (companionProductId && i.product_id === companionProductId)
          )
      );

      // ===== Gift 1: xóa nếu chỉ còn gift =====
      if (cart.items.length === 1) {
        const item = cart.items[0];
        const isOnlyGift =
          item.variant_id === variantId1 ||
          (companionProductId && item.product_id === companionProductId);
        if (isOnlyGift) {
          showCartLoading(true);
          await new Promise((r) => setTimeout(r, 100));
          await removeCartItem(item.key);
          cart = await (await fetch("/cart.js")).json();
          if (!cart.items.length) {
            await showEmptyCartState();
            // Tránh chạy tiếp logic thêm quà tặng khi giỏ đã trống
            return;
          } else {
            showCartLoading(false);
          }
        }
      }

      // ===== Gift 1: add nếu chưa có =====
      const hasGift1 = cart.items.some(
        (i) =>
          i.variant_id === variantId1 ||
          (companionProductId && i.product_id === companionProductId)
      );

      // Theo dõi cart có thay đổi không, cuối cùng chỉ reload UI 1 lần duy nhất
      let cartChanged = false;
      const addUrl =
        (window.routes && window.routes.cart_add_url) || "/cart/add.js";

      // Chỉ thêm quà tặng nếu đang có ít nhất một sản phẩm không phải quà
      if (hasNonGiftItems && !hasGift1) {
        const res = await fetch(addUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({ id: String(variantId1), quantity: 1 }),
        });
        if (res.ok) cartChanged = true;
        // Fetch lại cart sau khi thêm gift 1 (cần dữ liệu mới cho logic gift 2)
        cart = await (await fetch("/cart.js")).json();
      }

      // ===== Gift 2: xóa nếu không đủ điều kiện (tổng tiền < 3000) =====
      const gift2Item = cart.items.find(
        (i) =>
          i.variant_id === variantId2 ||
          (companionProductId2 && i.product_id === companionProductId2)
      );
      if (gift2Item && !isCartEligibleForSecondGift(cart)) {
        showCartLoading(true);
        await removeCartItem(gift2Item.key);
        cartChanged = true;
        showCartLoading(false);
      }

      // ===== Gift 2: add nếu tổng tiền >= 3000 và chưa có =====
      const hasGift2 = cart.items.some(
        (i) =>
          i.variant_id === variantId2 ||
          (companionProductId2 && i.product_id === companionProductId2)
      );
      if (isCartEligibleForSecondGift(cart) && !hasGift2) {
        const res = await fetch(addUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({ id: String(variantId2), quantity: 1 }),
        });
        if (res.ok) cartChanged = true;
      }

      // Chỉ reload UI 1 lần sau khi toàn bộ logic gift hoàn tất.
      // GHI CHÚ: Gọi reloadCart() ở đây sẽ dispatch "cart:updated" / "cart:refresh",
      // nhưng isCheckingCompanion vẫn = true nên các listener sẽ bị chặn bởi mutex,
      // KHÔNG tạo vòng lặp vô hạn. isCheckingCompanion chỉ reset sau 2s (xem finally).
      if (cartChanged) {
        if (window.reloadCart) window.reloadCart();
        else window.location.reload();
      }

    } catch (e) {
      console.error("Error checking companion products:", e);
    } finally {
      // Giữ mutex thêm 2s nếu cart đã thay đổi, để chặn các event listener
      // (cart:updated, cart:refresh) được reloadCart() trigger không gọi lại hàm này.
      // Nếu không thay đổi gì thì reset ngay.
      if (isCheckingCompanion) {
        setTimeout(() => { isCheckingCompanion = false; }, 2000);
      }
    }
  }

  // Function to remove cart items by line IDs
  async function removeCartItems(lineIds) {
    try {
      const updates = lineIds.reduce((acc, lineId) => {
        acc[lineId] = 0;
        return acc;
      }, {});

      const response = await fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ updates }),
      });

      if (response.ok) {
        const result = await response.json();
        // Reload the page to update the cart
        window.location.reload();
      }
    } catch (error) {
      // Silent error handling
    }
  }

  // Function to reload cart via AJAX (moved outside DOMContentLoaded for global access)
  window.reloadCart = function () {
    // First fetch cart data to check if cart is empty
    fetch("/cart.js")
      .then((response) => response.json())
      .then(async (cartData) => {
        if (cartData.items.length === 0) {
          // Cart is empty, show empty state
          await showEmptyCartState();
        } else {
          // Cart has items, fetch sections
          return fetch(window.location.pathname + "?sections=cart-drawer")
            .then((response) => {
              if (!response.ok) {
                throw new Error("Failed to fetch cart sections");
              }
              return response.text();
            })
            .then((html) => {
              try {
                // Parse the sections response
                const sectionsData = JSON.parse(html);

                const cartDrawerHTML = sectionsData["cart-drawer"];

                if (cartDrawerHTML) {
                  const tempDiv = document.createElement("div");
                  tempDiv.innerHTML = cartDrawerHTML;

                  // Update cart drawer content
                  const cartDrawer = document.querySelector("cart-drawer");

                  if (cartDrawer) {
                    const cartItemsContainer = cartDrawer.querySelector(
                      "#CartDrawer-CartItems"
                    );
                    const newCartItems = tempDiv.querySelector(
                      "#CartDrawer-CartItems"
                    );

                    if (cartItemsContainer && newCartItems) {
                      cartItemsContainer.innerHTML = newCartItems.innerHTML;
                    }

                    // Update cart drawer footer if exists
                    const cartDrawerFooter =
                      cartDrawer.querySelector(".drawer__footer");
                    const newCartDrawerFooter =
                      tempDiv.querySelector(".drawer__footer");

                    if (cartDrawerFooter && newCartDrawerFooter) {
                      cartDrawerFooter.innerHTML =
                        newCartDrawerFooter.innerHTML;
                    }
                  }
                }
              } catch (parseError) {
                // Silent error handling
              }
            });
        }
      })
      .then(() => {
        // Update cart icon bubble
        fetch(window.location.pathname + "?sections=cart-icon-bubble")
          .then((response) => response.text())
          .then((html) => {
            const sectionsData = JSON.parse(html);
            const cartIconHTML = sectionsData["cart-icon-bubble"];

            if (cartIconHTML) {
              const cartIconBubble = document.querySelector("cart-icon-bubble");
              if (cartIconBubble) {
                cartIconBubble.innerHTML = cartIconHTML;
              }
            }
          })
          .catch((error) => {
            // Silent error handling
          });
      })
      .then(() => {
        // Dispatch cart updated events
        document.dispatchEvent(new CustomEvent("cart:updated"));
        document.dispatchEvent(new CustomEvent("cart:refresh"));

        // Re-initialize ring size dropdowns
        setTimeout(() => {
          initializeRingSizeDropdowns();
        }, 100);
      })
      .catch((error) => {
        // Fallback: reload page if AJAX fails
        window.location.reload();
      });
  };

  // Function to remove bundle with addons first, then main product
  async function removeBundleWithAddons(bundleId) {
    try {
      // Get current cart
      const cart = await (await fetch("/cart.js")).json();

      // Separate addons and main product
      const addonsToRemove = [];
      const mainProductToRemove = [];
      const orphanedAddons = [];

      // First pass: collect items for the specific bundle
      cart.items.forEach((item, index) => {
        if (item.properties) {
          const itemBundleId =
            item.properties._bundle_id || item.properties.bundle_id;
          const isAddon = item.properties._is_addon === "true";
          const isMainProduct = item.properties._is_main_product === "true";

          if (itemBundleId === bundleId) {
            if (isAddon) {
              addonsToRemove.push(item.key);
            } else if (isMainProduct) {
              mainProductToRemove.push(item.key);
            }
          }
        }
      });

      // Second pass: find orphaned addons (addons without their main product)
      cart.items.forEach((item, index) => {
        if (item.properties && item.properties._is_addon === "true") {
          const itemBundleId =
            item.properties._bundle_id || item.properties.bundle_id;

          // Check if this addon's main product still exists
          const hasMainProduct = cart.items.some(
            (mainItem) =>
              mainItem.properties &&
              (mainItem.properties._bundle_id ||
                mainItem.properties.bundle_id) === itemBundleId &&
              mainItem.properties._is_main_product === "true"
          );

          // If no main product found, this addon is orphaned
          if (!hasMainProduct) {
            orphanedAddons.push(item.key);
          }
        }
      });

      // Show loading at the start
      showCartLoading(true);

      // Add a small delay to ensure loading is visible
      await new Promise((resolve) => setTimeout(resolve, 100));

      // Step 1: Remove addons first (both bundle addons and orphaned addons)
      const allAddonsToRemove = [...addonsToRemove, ...orphanedAddons];
      if (allAddonsToRemove.length > 0) {
        const addonUpdates = {};
        allAddonsToRemove.forEach((key) => {
          addonUpdates[key] = 0;
        });

        const addonResponse = await fetch("/cart/update.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            updates: addonUpdates,
            sections: ["cart-drawer", "cart-icon-bubble"],
            sections_url: window.location.pathname,
          }),
        });

        if (!addonResponse.ok) {
          throw new Error("Failed to remove addons");
        }

        const addonResult = await addonResponse.json();

        // Update UI immediately after addon removal
        updateCartUI(addonResult.sections);

        // Also update cart icon bubble
        if (addonResult.sections && addonResult.sections["cart-icon-bubble"]) {
          const cartIconBubble = document.getElementById("cart-icon-bubble");
          if (cartIconBubble) {
            // Extract the content from the section wrapper
            const tempDiv = document.createElement("div");
            tempDiv.innerHTML = addonResult.sections["cart-icon-bubble"];
            const sectionContent = tempDiv.querySelector(".shopify-section");
            if (sectionContent) {
              cartIconBubble.innerHTML = sectionContent.innerHTML;
            }
          }
        }

        // Wait a bit before removing main product
        await new Promise((resolve) => setTimeout(resolve, 1000));
      }

      // Step 2: Remove main product
      if (mainProductToRemove.length > 0) {
        // Check cart state after addon removal
        const cartAfterAddons = await (await fetch("/cart.js")).json();

        // Find main product in current cart (key might have changed after addon removal)
        const currentMainProduct = cartAfterAddons.items.find((item) => {
          if (!item.properties) return false;
          const itemBundleId =
            item.properties._bundle_id || item.properties.bundle_id;
          const isMainProduct = item.properties._is_main_product === "true";
          return itemBundleId === bundleId && isMainProduct;
        });

        if (currentMainProduct) {
          const mainUpdates = {};
          mainUpdates[currentMainProduct.key] = 0;

          const mainResponse = await fetch("/cart/update.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify({
              updates: mainUpdates,
              sections: ["cart-drawer", "cart-icon-bubble"],
              sections_url: window.location.pathname,
            }),
          });

          if (!mainResponse.ok) {
            throw new Error("Failed to remove main product");
          }

          const mainResult = await mainResponse.json();

          // Update UI immediately after main product removal
          updateCartUI(mainResult.sections);

          // Also update cart icon bubble
          if (mainResult.sections && mainResult.sections["cart-icon-bubble"]) {
            const cartIconBubble = document.getElementById("cart-icon-bubble");
            if (cartIconBubble) {
              // Extract the content from the section wrapper
              const tempDiv = document.createElement("div");
              tempDiv.innerHTML = mainResult.sections["cart-icon-bubble"];
              const sectionContent = tempDiv.querySelector(".shopify-section");
              if (sectionContent) {
                cartIconBubble.innerHTML = sectionContent.innerHTML;
              }
            }
          }

          // Check if cart is now empty after removing main product
          const cartAfterMainRemoval = await (await fetch("/cart.js")).json();
          if (cartAfterMainRemoval.items.length === 0) {
            // Cart is empty, show empty state immediately
            await showEmptyCartState();
            return {
              success: true,
              addonsRemoved: addonsToRemove.length,
              orphanedAddonsRemoved: orphanedAddons.length,
              mainProductsRemoved: mainProductToRemove.length,
              bundleId: bundleId,
            };
          } else {
            // Cart still has items, hide loading
            showCartLoading(false);
            return {
              success: true,
              addonsRemoved: addonsToRemove.length,
              orphanedAddonsRemoved: orphanedAddons.length,
              mainProductsRemoved: mainProductToRemove.length,
              bundleId: bundleId,
            };
          }
        }
      }

      // Hide loading if no main product was removed
      showCartLoading(false);

      return {
        success: true,
        addonsRemoved: addonsToRemove.length,
        orphanedAddonsRemoved: orphanedAddons.length,
        mainProductsRemoved: mainProductToRemove.length,
        bundleId: bundleId,
      };
    } catch (err) {
      // Hide loading on error
      showCartLoading(false);
      throw err;
    }
  }

  // Test function to check loading (remove this later)
  window.testCartLoading = function () {
    showCartLoading(true);
    setTimeout(() => {
      showCartLoading(false);
    }, 3000);
  };

  // Helper function to show/hide loading state in cart drawer
  function showCartLoading(show = true) {
    const cartDrawer = document.querySelector("cart-drawer");
    if (!cartDrawer) {
      return;
    }

    if (show) {
      // Remove existing loading overlay if any
      const existingOverlay = document.getElementById("cart-loading-overlay");
      if (existingOverlay) {
        existingOverlay.remove();
      }

      // Create loading overlay at cart-drawer level (not inside drawer__inner)
      const loadingOverlay = document.createElement("div");
      loadingOverlay.id = "cart-loading-overlay";
      loadingOverlay.style.cssText = `
           position: absolute;
           display: block;
           top: 0;
           left: 0;
           right: 0;
           bottom: 0;
           background: rgba(0, 0, 0, 0.5);
           display: flex;
           align-items: center;
           justify-content: center;
           z-index: 1000;
           backdrop-filter: blur(3px);
           -webkit-backdrop-filter: blur(3px);
         `;

      // Create loading spinner
      const spinner = document.createElement("div");
      spinner.style.cssText = `
           width: 60px;
           height: 60px;
           display: block;
           border: 6px solid rgba(255, 255, 255, 0.3);
           border-top: 6px solid #ffffff;
           border-radius: 50%;
           animation: cart-spin 1s linear infinite;
           box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
         `;

      // Add CSS animation
      if (!document.getElementById("cart-loading-styles")) {
        const style = document.createElement("style");
        style.id = "cart-loading-styles";
        style.textContent = `
             @keyframes cart-spin {
               0% { transform: rotate(0deg); }
               100% { transform: rotate(360deg); }
             }
             #cart-loading-overlay {
               animation: fadeIn 0.3s ease-in;
             }
             @keyframes fadeIn {
               from { opacity: 0; }
               to { opacity: 1; }
             }
           `;
        document.head.appendChild(style);
      }

      loadingOverlay.appendChild(spinner);

      // Find #CartDrawer element inside cart-drawer
      const cartDrawerInner = cartDrawer.querySelector("#CartDrawer");
      if (cartDrawerInner) {
        // Ensure #CartDrawer has relative positioning
        cartDrawerInner.style.position = "relative";

        // Add to #CartDrawer
        cartDrawerInner.appendChild(loadingOverlay);
      } else {
        // Fallback to cart-drawer if #CartDrawer not found
        cartDrawer.style.position = "relative";
        cartDrawer.appendChild(loadingOverlay);
      }
    } else {
      // Remove loading overlay
      const loadingOverlay = document.getElementById("cart-loading-overlay");
      if (loadingOverlay) {
        loadingOverlay.style.opacity = "0";
        setTimeout(() => {
          if (loadingOverlay.parentNode) {
            loadingOverlay.remove();
          }
        }, 300);
      }
    }
  }

  // Helper function to show empty cart state by fetching fresh cart-drawer section
  async function showEmptyCartState() {
    try {
      // Fetch fresh cart-drawer section
      const response = await fetch(
        window.location.pathname + "?sections=cart-drawer"
      );
      if (!response.ok) {
        throw new Error("Failed to fetch cart-drawer section");
      }

      const html = await response.text();
      const sectionsData = JSON.parse(html);
      const cartDrawerHTML = sectionsData["cart-drawer"];

      if (cartDrawerHTML) {
        const cartDrawer = document.querySelector("cart-drawer");
        if (cartDrawer) {
          // Parse the fetched HTML to extract only the inner content
          const tempDiv = document.createElement("div");
          tempDiv.innerHTML = cartDrawerHTML;

          // Get the inner content (everything inside <cart-drawer> tag)
          const newCartDrawer = tempDiv.querySelector("cart-drawer");
          if (newCartDrawer) {
            // Replace only the inner content, not the cart-drawer tag itself
            cartDrawer.innerHTML = newCartDrawer.innerHTML;
            cartDrawer.classList.add("is-empty");

            // Update cart icon bubble for empty state
            // Add a small delay to ensure cart is updated on server
            setTimeout(() => {
              fetch(
                window.location.pathname +
                "?sections=cart-icon-bubble&t=" +
                Date.now()
              )
                .then((response) => response.text())
                .then((html) => {
                  const sectionsData = JSON.parse(html);
                  const cartIconHTML = sectionsData["cart-icon-bubble"];
                  if (cartIconHTML) {
                    const cartIconBubble =
                      document.getElementById("cart-icon-bubble");
                    if (cartIconBubble) {
                      // Extract the content from the section wrapper
                      const tempDiv = document.createElement("div");
                      tempDiv.innerHTML = cartIconHTML;
                      const sectionContent =
                        tempDiv.querySelector(".shopify-section");
                      if (sectionContent) {
                        cartIconBubble.innerHTML = sectionContent.innerHTML;
                      }
                    }
                  }
                })
                .catch((error) => {
                  console.error("Error updating cart icon bubble:", error);
                });
            }, 500);

            // Re-initialize any necessary functionality
            setTimeout(() => {
              initializeRingSizeDropdowns();
            }, 100);
          }
        }
      }
    } catch (error) {
      console.error("Error fetching empty cart state:", error);
    } finally {
      // Always hide loading when done
      showCartLoading(false);
    }
  }

  // Helper function to update cart UI with sections response
  function updateCartUI(sections) {
    if (!sections) return;

    // Update cart drawer content
    const cartDrawer = document.querySelector("cart-drawer");
    if (cartDrawer && sections["cart-drawer"]) {
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = sections["cart-drawer"];

      // Check if the response contains empty state
      const hasEmptyState = tempDiv.querySelector(".drawer__inner-empty");

      if (hasEmptyState) {
        // Show empty state
        showEmptyCartState();
      } else {
        // Update normal cart content
        const cartItemsContainer = cartDrawer.querySelector(
          "#CartDrawer-CartItems"
        );
        const newCartItems = tempDiv.querySelector("#CartDrawer-CartItems");

        if (cartItemsContainer && newCartItems) {
          cartItemsContainer.innerHTML = newCartItems.innerHTML;
        }

        // Update cart drawer footer
        const cartDrawerFooter = cartDrawer.querySelector(".drawer__footer");
        const newCartDrawerFooter = tempDiv.querySelector(".drawer__footer");

        if (cartDrawerFooter && newCartDrawerFooter) {
          cartDrawerFooter.innerHTML = newCartDrawerFooter.innerHTML;
        }
      }
    }

    // Update cart icon bubble
    if (sections["cart-icon-bubble"]) {
      // Update the actual cart icon in header
      const cartIconBubble = document.getElementById("cart-icon-bubble");
      if (cartIconBubble) {
        // Extract the content from the section wrapper
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = sections["cart-icon-bubble"];
        const sectionContent = tempDiv.querySelector(".shopify-section");
        if (sectionContent) {
          cartIconBubble.innerHTML = sectionContent.innerHTML;
        }
      }
    }
  }

  // Function to clean up orphaned addons (addons without their main product)
  async function cleanupOrphanedAddons() {
    try {
      // Get current cart
      const cart = await (await fetch("/cart.js")).json();

      const orphanedAddons = [];

      // Find orphaned addons (addons without their main product)
      cart.items.forEach((item, index) => {
        if (item.properties && item.properties._is_addon === "true") {
          const itemBundleId =
            item.properties._bundle_id || item.properties.bundle_id;

          // Check if this addon's main product still exists
          const hasMainProduct = cart.items.some(
            (mainItem) =>
              mainItem.properties &&
              (mainItem.properties._bundle_id ||
                mainItem.properties.bundle_id) === itemBundleId &&
              mainItem.properties._is_main_product === "true"
          );

          // If no main product found, this addon is orphaned
          if (!hasMainProduct) {
            orphanedAddons.push(item.key);
          }
        }
      });

      // Remove orphaned addons if any found
      if (orphanedAddons.length > 0) {
        const addonUpdates = {};
        orphanedAddons.forEach((key) => {
          addonUpdates[key] = 0;
        });

        const response = await fetch("/cart/update.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            updates: addonUpdates,
            sections: ["cart-drawer", "cart-icon-bubble"],
            sections_url: window.location.pathname,
          }),
        });

        if (!response.ok) {
          throw new Error("Failed to remove orphaned addons");
        }

        const result = await response.json();

        // Update UI immediately after orphaned addon removal
        updateCartUI(result.sections);

        return {
          success: true,
          orphanedAddonsRemoved: orphanedAddons.length,
        };
      }

      return {
        success: true,
        orphanedAddonsRemoved: 0,
      };
    } catch (err) {
      throw err;
    }
  }

  // Function to remove bundle by bundle ID (legacy function for single item removal)
  async function removeBundle(bundleId) {
    try {
      // Lấy cart hiện tại
      const cart = await (await fetch("/cart.js")).json();

      // Tạo updates object với lineItemKey = 0
      const updates = {};

      cart.items.forEach((item, index) => {
        if (item.properties) {
          // Check both _bundle_id and bundle_id properties
          const itemBundleId =
            item.properties._bundle_id || item.properties.bundle_id;

          if (itemBundleId === bundleId) {
            updates[item.key] = 0; // dùng item.key để xoá line cụ thể
          } else if (itemBundleId && bundleId) {
            // Try partial matching for different bundle ID formats
            const itemBundleIdStr = String(itemBundleId);
            const bundleIdStr = String(bundleId);

            // Extract product ID and timestamp from bundle ID (format: bundle_PRODUCTID_TIMESTAMP)
            const bundleProductId = bundleIdStr.split("_")[1];
            const bundleTimestamp = bundleIdStr.split("_")[2];
            const itemProductId = itemBundleIdStr.split("_")[1];
            const itemTimestamp = itemBundleIdStr.split("_")[2];

            // Only match if both product ID and timestamp match (same bundle)
            if (
              bundleProductId === itemProductId &&
              bundleTimestamp === itemTimestamp
            ) {
              updates[item.key] = 0;
            }
          }
        }
      });

      if (Object.keys(updates).length === 0) {
        return cart;
      }

      // Gửi 1 request duy nhất
      const response = await fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          updates,
          sections: ["cart-drawer", "cart-icon-bubble"],
          sections_url: window.location.pathname,
        }),
      });

      if (!response.ok) {
        throw new Error("Request failed");
      }

      const result = await response.json();

      // Reload cart via AJAX
      window.reloadCart();

      return result;
    } catch (err) {
      throw err;
    }
  }

  // Override cart remove button clicks
  document.addEventListener("click", function (e) {
    // Look for cart remove button directly
    const cartRemoveButton = e.target.closest("cart-remove-button");
    if (!cartRemoveButton) {
      return;
    }

    e.preventDefault();

    // Get the line ID from the cart remove button
    const lineId = cartRemoveButton.getAttribute("data-index");
    if (!lineId) return;

    // Fetch current cart data dynamically
    fetch("/cart.js")
      .then((response) => response.json())
      .then((cartData) => {
        const cartItems = cartData.items;

        // Use array index instead of item.index since API doesn't provide index
        const itemToRemove = cartItems[lineId - 1]; // lineId is 1-based, array is 0-based

        if (!itemToRemove) {
          return;
        }

        // Continue with the rest of the logic
        processItemRemoval(itemToRemove, cartItems, cartRemoveButton);
      })
      .catch((error) => {
        // Silent error handling
      });

    // Function to process item removal after cart data is fetched
    function processItemRemoval(itemToRemove, cartItems, cartRemoveButton) {
      // Get bundle_id from the data attribute or properties
      let bundleId = cartRemoveButton.getAttribute("data-bundle-id");

      if (!bundleId && itemToRemove.properties) {
        const bundleIdProp = itemToRemove.properties.find(
          (prop) => prop[0] === "_bundle_id"
        );
        if (bundleIdProp) {
          bundleId = bundleIdProp[1];
        }
      }

      if (bundleId) {
        // Check if this is a main product with addons
        const isMainProduct =
          itemToRemove.properties &&
          itemToRemove.properties._is_main_product === "true";

        if (isMainProduct) {
          // Count addons in this bundle
          const addonCount = cartItems.filter((item) => {
            if (!item.properties) return false;
            const itemBundleId = item.properties._bundle_id;
            const isAddon = item.properties._is_addon === "true";
            return itemBundleId === bundleId && isAddon;
          }).length;
        }

        // Remove bundle with addons first, then main product
        removeBundleWithAddons(bundleId)
          .then((result) => {
            // Silent success
          })
          .catch((error) => {
            showNotification(
              "There was an error while updating your cart. Please try again.",
              "error"
            );
          });
      } else {
        const updates = {};
        updates[itemToRemove.key] = 0;

        fetch("/cart/update.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            updates,
            sections: ["cart-drawer", "cart-icon-bubble"],
            sections_url: window.location.pathname,
          }),
        })
          .then((response) => {
            if (response.ok) {
              return response.json();
            } else {
              throw new Error(
                `HTTP ${response.status}: ${response.statusText}`
              );
            }
          })
          .then((result) => {
            window.reloadCart();
          })
          .catch((error) => {
            showNotification(
              "There was an error while updating your cart. Please try again.",
              "error"
            );
          });
      }
    }
  });

  // Handle toggle addons functionality
  document.addEventListener("click", function (e) {
    const toggleButton = e.target.closest(".cart-item__toggle-addons");
    if (!toggleButton) return;

    e.preventDefault();

    const bundleId = toggleButton.getAttribute("data-bundle-id");
    const addonsContainer = document.getElementById(`addons-${bundleId}`);
    const toggleIcon = toggleButton.querySelector(".cart-item__toggle-icon");

    if (addonsContainer && toggleIcon) {
      const isHidden = addonsContainer.style.display === "none";

      if (isHidden) {
        addonsContainer.style.display = "flex";
        toggleIcon.style.transform = "rotate(180deg)";
        toggleButton.setAttribute("aria-expanded", "true");
      } else {
        addonsContainer.style.display = "none";
        toggleIcon.style.transform = "rotate(0deg)";
        toggleButton.setAttribute("aria-expanded", "false");
      }
    }
  });

  // Initialize ring size dropdowns on page load
  function initializeRingSizeDropdowns() {
    document.querySelectorAll(".ring-size-dropdown").forEach((dropdown) => {
      const currentSizeSpan = dropdown.querySelector(".current-size");
      const currentSize = currentSizeSpan
        ? currentSizeSpan.textContent.trim()
        : "";

      if (currentSize && currentSize !== "Select Size") {
        dropdown.querySelectorAll(".ring-size-option").forEach((option) => {
          const optionSize = option.getAttribute("data-size");
          const checkIcon = option.querySelector(".ring-size-check");

          if (optionSize === currentSize) {
            option.classList.add("selected", "active");
            if (checkIcon) {
              checkIcon.style.opacity = "1";
            }
          }
        });
      }
    });
  }

  // Try multiple times to ensure elements are loaded
  document.addEventListener("DOMContentLoaded", function () {
    // Try immediately
    initializeRingSizeDropdowns();

    // Try again after a short delay
    setTimeout(initializeRingSizeDropdowns, 100);

    // Try again after cart drawer might be loaded
    setTimeout(initializeRingSizeDropdowns, 500);
  });

  // Also try when cart drawer is opened
  document.addEventListener("cart:opened", function () {
    setTimeout(initializeRingSizeDropdowns, 100);
  });

  // Try when cart drawer is shown/opened
  const cartDrawerElement = document.querySelector("cart-drawer");
  if (cartDrawerElement) {
    // Override the open method to initialize ring sizes and cleanup orphaned addons
    const originalOpen = cartDrawerElement.open;
    if (originalOpen) {
      cartDrawerElement.open = function () {
        originalOpen.call(this);
        setTimeout(initializeRingSizeDropdowns, 100);
        // Cleanup orphaned addons when cart drawer opens
        setTimeout(() => {
          cleanupOrphanedAddons().catch((error) => {
            // Silent error handling for orphaned addon cleanup
          });
        }, 200);
        // Check and add companion product when cart drawer opens
        setTimeout(checkAndAddCompanionProduct, 300);
      };
    }
  }

  // Watch for cart drawer content changes
  const cartDrawer = document.querySelector("cart-drawer");
  if (cartDrawer) {
    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === "childList" && mutation.addedNodes.length > 0) {
          // Check if ring size dropdowns were added
          const hasRingSizeDropdowns = Array.from(mutation.addedNodes).some(
            (node) => {
              if (node.nodeType === 1) {
                // Element node
                return (
                  node.querySelector &&
                  node.querySelector(".ring-size-dropdown")
                );
              }
              return false;
            }
          );

          if (hasRingSizeDropdowns) {
            setTimeout(initializeRingSizeDropdowns, 50);
          }
        }
      });
    });

    observer.observe(cartDrawer, {
      childList: true,
      subtree: true,
    });
  }

  // Handle ring size dropdown functionality
  document.addEventListener("click", function (e) {
    // Handle ring size button click
    const ringSizeButton = e.target.closest(".ring-size-button");
    if (ringSizeButton) {
      e.preventDefault();
      e.stopPropagation();

      const dropdown = ringSizeButton.closest(".ring-size-dropdown");
      const options = dropdown.querySelector(".ring-size-options");
      const caretIcon = dropdown.querySelector(".caret-icon");

      // Toggle dropdown
      if (options.classList.contains("hidden")) {
        // Close other dropdowns
        document.querySelectorAll(".ring-size-options").forEach((opt) => {
          opt.classList.add("hidden");
        });
        document.querySelectorAll(".caret-icon").forEach((icon) => {
          icon.style.transform = "rotate(0deg)";
        });

        // Highlight current selected option
        const currentSize = dropdown.querySelector(".current-size").textContent;
        dropdown.querySelectorAll(".ring-size-option").forEach((option) => {
          option.classList.remove("selected", "active");
          const checkIcon = option.querySelector(".ring-size-check");
          if (checkIcon) {
            checkIcon.style.opacity = "0";
          }
          if (option.getAttribute("data-size") === currentSize) {
            option.classList.add("selected", "active");
            if (checkIcon) {
              checkIcon.style.opacity = "1";
            }
          }
        });

        // Open current dropdown
        options.classList.remove("hidden");
        caretIcon.style.transform = "rotate(180deg)";
        ringSizeButton.setAttribute("aria-expanded", "true");
      } else {
        // Close current dropdown
        options.classList.add("hidden");
        caretIcon.style.transform = "rotate(0deg)";
        ringSizeButton.setAttribute("aria-expanded", "false");
      }
    }

    // Handle ring size option click
    const ringSizeOption = e.target.closest(".ring-size-option");
    if (ringSizeOption) {
      e.preventDefault();
      e.stopPropagation();

      const newSize = ringSizeOption.getAttribute("data-size");
      const dropdown = ringSizeOption.closest(".ring-size-dropdown");
      const itemKey = dropdown.getAttribute("data-item-key");
      const currentSizeSpan = dropdown.querySelector(".current-size");
      const options = dropdown.querySelector(".ring-size-options");
      const caretIcon = dropdown.querySelector(".caret-icon");

      // Remove selected class from all options
      dropdown.querySelectorAll(".ring-size-option").forEach((option) => {
        option.classList.remove("selected", "active");
        const checkIcon = option.querySelector(".ring-size-check");
        if (checkIcon) {
          checkIcon.style.opacity = "0";
        }
      });

      // Add selected class to clicked option
      ringSizeOption.classList.add("selected", "active");
      const checkIcon = ringSizeOption.querySelector(".ring-size-check");
      if (checkIcon) {
        checkIcon.style.opacity = "1";
      }

      // Update display
      currentSizeSpan.textContent = newSize;

      // Close dropdown
      options.classList.add("hidden");
      caretIcon.style.transform = "rotate(0deg)";
      dropdown
        .querySelector(".ring-size-button")
        .setAttribute("aria-expanded", "false");

      // Update cart
      updateRingSize(itemKey, newSize);
    }

    // Close dropdowns when clicking outside
    if (!e.target.closest(".ring-size-dropdown")) {
      document.querySelectorAll(".ring-size-options").forEach((opt) => {
        opt.classList.add("hidden");
      });
      document.querySelectorAll(".caret-icon").forEach((icon) => {
        icon.style.transform = "rotate(0deg)";
      });
      document.querySelectorAll(".ring-size-button").forEach((btn) => {
        btn.setAttribute("aria-expanded", "false");
      });
    }
  });

  // Function to update ring size in cart
  async function updateRingSize(itemKey, newSize) {
    try {
      // Set checkout button to loading/disabled state
      const checkoutBtn = document.getElementById("CartDrawer-Checkout");
      if (checkoutBtn && !checkoutBtn.classList.contains("is-loading")) {
        checkoutBtn.dataset.originalHtml = checkoutBtn.innerHTML;
        checkoutBtn.disabled = true;
        checkoutBtn.classList.add("is-loading");
        checkoutBtn.setAttribute("aria-busy", "true");
        checkoutBtn.innerHTML =
          '<span class="loading-spinner"></span> Updating...';
      }

      // Get the line item ID from the item key by finding it in the DOM
      // This ensures we get the most up-to-date cart items
      const cartItemElement = document.querySelector(
        `[data-item-key="${itemKey}"]`
      );
      if (!cartItemElement) {
        showNotification("Item not found in cart", "error");
        return;
      }

      // Find the parent cart item group to get the line index
      const cartItemGroup = cartItemElement.closest(".cart-item-group");
      if (!cartItemGroup) {
        showNotification("Unable to update ring size", "error");
        return;
      }

      // Get the line item index from the data attribute
      const lineIndex = cartItemGroup
        .querySelector(".cart-item--main")
        .getAttribute("data-line-index");
      if (!lineIndex) {
        showNotification("Unable to update ring size", "error");
        return;
      }

      const lineId = parseInt(lineIndex) + 1;
      const attributeKey = `ring_size_${itemKey}`;

      // Read current cart to preserve existing properties on the line
      const cartRes = await fetch("/cart.js");
      if (!cartRes.ok) {
        showNotification("Unable to update ring size", "error");
        return;
      }
      const cartJson = await cartRes.json();
      const targetItem = (cartJson.items || []).find(
        (it) => it.key === itemKey
      );

      // Determine bundle scope (if any)
      const targetProps =
        targetItem && targetItem.properties ? targetItem.properties : {};
      const bundleId =
        (targetProps && (targetProps._bundle_id || targetProps.bundle_id)) ||
        null;

      // Build list of items to update: target + any addons in same bundle
      const itemsToUpdate = [];
      if (bundleId) {
        (cartJson.items || []).forEach((it, idx) => {
          const props = it.properties || {};
          const itBundleId = props._bundle_id || props.bundle_id;
          if (itBundleId === bundleId) {
            itemsToUpdate.push({ item: it, line: idx + 1 });
          }
        });
      } else if (targetItem) {
        // Only the single item
        const idx = (cartJson.items || []).findIndex(
          (it) => it.key === targetItem.key
        );
        if (idx !== -1) {
          itemsToUpdate.push({ item: targetItem, line: idx + 1 });
        }
      }

      // If no items found fall back to the original computed line
      if (itemsToUpdate.length === 0) {
        const fallbackExistingProps =
          targetItem && targetItem.properties ? targetItem.properties : {};
        const fallbackNewProps = Object.assign({}, fallbackExistingProps, {
          "Select Ring Size": newSize,
        });
        const singleRes = await fetch("/cart/change.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            line: lineId,
            properties: fallbackNewProps,
          }),
        });
        if (!singleRes.ok) {
          showNotification(
            "Failed to update ring size. Please try again.",
            "error"
          );
          return;
        }
      } else {
        // Update each item (main + addons in bundle) with new ring size property
        for (const { item, line } of itemsToUpdate) {
          const existingProps = item.properties ? item.properties : {};
          const mergedProps = Object.assign({}, existingProps, {
            "Select Ring Size": newSize,
          });

          // Send change for this line
          const res = await fetch("/cart/change.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify({
              line: line,
              properties: mergedProps,
            }),
          });

          if (!res.ok) {
            showNotification(
              "Failed to update ring size for all items. Please try again.",
              "error"
            );
            return;
          }
        }
      }

      {
        // Clear any temporary cart attribute used for UI syncing
        try {
          await fetch("/cart/update.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify({
              attributes: {
                [attributeKey]: null,
              },
            }),
          });
        } catch (e) {
          // no-op: attribute cleanup failure shouldn't block UX
        }

        // Update the display immediately
        const currentSizeSpan = document.querySelector(
          `[data-item-key="${itemKey}"] .current-size`
        );
        if (currentSizeSpan) {
          currentSizeSpan.textContent = newSize;
        }

        // Update the selected option in dropdown
        const dropdown = document.querySelector(`[data-item-key="${itemKey}"]`);
        if (dropdown) {
          dropdown.querySelectorAll(".ring-size-option").forEach((option) => {
            option.classList.remove("selected", "active");
            const checkIcon = option.querySelector(".ring-size-check");
            if (checkIcon) {
              checkIcon.style.opacity = "0";
            }
            if (option.getAttribute("data-size") === newSize) {
              option.classList.add("selected", "active");
              if (checkIcon) {
                checkIcon.style.opacity = "1";
              }
            }
          });
        }

        // Trigger cart update event for other components
        document.dispatchEvent(new CustomEvent("cart:updated"));

        // Refresh cart drawer content to ensure consistency
        setTimeout(() => {
          refreshCartDrawer();
          // After refresh, ensure checkout state reflects latest sizes
          if (window.updateCartDrawerCheckoutState) {
            window.updateCartDrawerCheckoutState();
          }
        }, 500);

        // Also update checkout state immediately to avoid race before DOM refresh
        if (window.updateCartDrawerCheckoutState) {
          window.updateCartDrawerCheckoutState();
        }

        // Show success message
        showNotification("Ring size updated successfully!", "success");
      }
    } catch (error) {
      showNotification("Error updating ring size. Please try again.", "error");
    } finally {
      // Restore checkout button state and re-evaluate disabled status
      const checkoutBtn = document.getElementById("CartDrawer-Checkout");
      if (checkoutBtn) {
        checkoutBtn.classList.remove("is-loading");
        checkoutBtn.removeAttribute("aria-busy");
        if (checkoutBtn.dataset.originalHtml) {
          checkoutBtn.innerHTML = checkoutBtn.dataset.originalHtml;
          delete checkoutBtn.dataset.originalHtml;
        }
        // Temporarily enable; the updater below will enforce disabled if still missing size
        checkoutBtn.disabled = false;
      }
      if (window.updateCartDrawerCheckoutState) {
        window.updateCartDrawerCheckoutState();
      }
    }
  }

  // Function to refresh cart drawer content
  async function refreshCartDrawer() {
    try {
      // Fetch updated cart data
      const response = await fetch("/cart.js");
      if (response.ok) {
        const cartData = await response.json();

        // Update cart drawer content
        const cartDrawerItems = document.querySelector("#CartDrawer-CartItems");
        if (cartDrawerItems) {
          // Trigger a cart drawer refresh by dispatching a custom event
          // This will cause the cart drawer to re-render with updated data
          document.dispatchEvent(new CustomEvent("cart:refresh"));
        }
      }
    } catch (error) {
      // Silent error handling
    }
  }

  // Function to show notification
  function showNotification(message, type = "info") {
    // Create notification element
    const notification = document.createElement("div");
    notification.className = `notification notification--${type}`;
    notification.textContent = message;

    // Add styles
    Object.assign(notification.style, {
      position: "fixed",
      top: "20px",
      right: "20px",
      padding: "12px 20px",
      borderRadius: "6px",
      color: "white",
      fontSize: "14px",
      fontWeight: "500",
      zIndex: "9999",
      opacity: "0",
      transform: "translateX(100%)",
      transition: "all 0.3s ease",
      backgroundColor:
        type === "success"
          ? "#10b981"
          : type === "error"
            ? "#ef4444"
            : "#3b82f6",
    });

    document.body.appendChild(notification);

    // Animate in
    setTimeout(() => {
      notification.style.opacity = "1";
      notification.style.transform = "translateX(0)";
    }, 100);

    // Remove after 3 seconds
    setTimeout(() => {
      notification.style.opacity = "0";
      notification.style.transform = "translateX(100%)";
      setTimeout(() => {
        if (notification.parentNode) {
          notification.parentNode.removeChild(notification);
        }
      }, 300);
    }, 3000);
  }

  // Handle discount code toggle
  document.addEventListener("click", function (e) {
    const toggleBtn = e.target.closest(".discount-code-toggle");
    if (toggleBtn) {
      const content = toggleBtn.nextElementSibling;
      const icon = toggleBtn.querySelector(".toggle-icon");
      if (content && content.classList.contains("discount-code-content")) {
        if (content.style.display === "none") {
          content.style.display = "block";
          icon.textContent = "−";
        } else {
          content.style.display = "none";
          icon.textContent = "+";
        }
      }
    }
  });

  // Handle discount code form submission
  document.addEventListener("submit", function (e) {
    const form = e.target.closest(".discount-code-form");
    if (!form) return;

    e.preventDefault();

    const input = form.querySelector("#discount-code-input");
    const code = input.value.trim();

    if (!code) {
      alert("Please enter a discount code");
      return;
    }

    const submitBtn = form.querySelector('button[type="submit"]');
    const originalText = submitBtn.textContent;
    submitBtn.disabled = true;
    submitBtn.innerHTML = '<span class="loading-spinner"></span> Applying...';

    // Use Storefront API to apply discount code
    const mutation = `
      mutation cartDiscountCodesUpdate($cartId: ID!, $discountCodes: [String!]) {
        cartDiscountCodesUpdate(cartId: $cartId, discountCodes: $discountCodes) {
          cart {
            id
            discountCodes {
              code
              applicable
            }
          }
          userErrors {
            field
            message
          }
        }
      }
    `;

    // Get cart ID from current cart
    fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        const cartId = `gid://shopify/Cart/${cart.token}`;

        return fetch("/api/2023-10/graphql.json", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Shopify-Storefront-Access-Token": window.ShopifyStorefrontToken,
          },
          body: JSON.stringify({
            query: mutation,
            variables: {
              cartId: cartId,
              discountCodes: [code],
            },
          }),
        });
      })
      .then((response) => response.json())
      .then((data) => {
        if (data.data.cartDiscountCodesUpdate.userErrors.length === 0) {
          if (window.reloadCart) {
            window.reloadCart();
          } else {
            window.location.reload();
          }
        } else {
          throw new Error(
            data.data.cartDiscountCodesUpdate.userErrors[0].message
          );
        }
      })
      .catch(() => {
        alert("Failed to apply discount code. Please try again.");
        submitBtn.disabled = false;
        submitBtn.textContent = originalText;
      });
  });

  // Handle remove discount code button
  document.addEventListener("click", function (e) {
    const removeBtn = e.target.closest(".remove-discount-code");
    if (removeBtn) {
      e.preventDefault();

      const code = removeBtn.getAttribute("data-code");
      if (!code) return;

      removeBtn.disabled = true;
      const originalText = removeBtn.innerHTML;
      removeBtn.innerHTML = '<span class="loading-spinner"></span>';

      // Use Storefront API to remove discount code
      const mutation = `
        mutation cartDiscountCodesUpdate($cartId: ID!, $discountCodes: [String!]) {
          cartDiscountCodesUpdate(cartId: $cartId, discountCodes: $discountCodes) {
            cart {
              id
              discountCodes {
                code
                applicable
              }
            }
            userErrors {
              field
              message
            }
          }
        }
      `;

      // Get cart ID from current cart
      fetch("/cart.js")
        .then((response) => response.json())
        .then((cart) => {
          const cartId = `gid://shopify/Cart/${cart.token}`;

          return fetch("/api/2023-10/graphql.json", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-Shopify-Storefront-Access-Token":
                window.ShopifyStorefrontToken,
            },
            body: JSON.stringify({
              query: mutation,
              variables: {
                cartId: cartId,
                discountCodes: [], // Empty array to remove all discount codes
              },
            }),
          });
        })
        .then((response) => response.json())
        .then((data) => {
          if (data.data.cartDiscountCodesUpdate.userErrors.length === 0) {
            if (window.reloadCart) {
              window.reloadCart();
            } else {
              window.location.reload();
            }
          } else {
            throw new Error(
              data.data.cartDiscountCodesUpdate.userErrors[0].message
            );
          }
        })
        .catch(() => {
          alert("Failed to remove discount code. Please try again.");
          removeBtn.disabled = false;
          removeBtn.innerHTML = originalText;
        });
    }
  });

  // Chạy check khi:
  // 1. Page load
  checkAndAddCompanionProduct();

  // 2. Khi cart được update
  document.addEventListener("cart:updated", function () {
    setTimeout(checkAndAddCompanionProduct, 500);
  });

  // 3. Khi cart được refresh
  document.addEventListener("cart:refresh", function () {
    setTimeout(checkAndAddCompanionProduct, 500);
  });

  // 4. Listen to PUB_SUB_EVENTS.cartUpdate nếu có
  if (
    typeof subscribe !== "undefined" &&
    typeof PUB_SUB_EVENTS !== "undefined"
  ) {
    try {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        setTimeout(checkAndAddCompanionProduct, 500);
      });
    } catch (e) {
      // PUB_SUB_EVENTS might not be available, ignore
    }
  }
});
